export interface EntitySchemaExclusionOptions {

    /**
     * Exclusion constraint name.
     */
    name?: string;

    /**
     * Exclusion expression.
     */
    expression: string;

}
